export async function requestNotificationPermissions(): Promise<boolean> {
    return false
}

export async function sendAuthFailureNotification(): Promise<void> {}

export async function registerPushToken(): Promise<void> {}

export async function unregisterPushToken(): Promise<void> {}

export function setupNotificationResponseListener(): () => void {
    return () => {}
}
